/* Frengidis Tools — category explorer, accessible and responsive. */
(()=>{'use strict';
  if(window.__fgCategoryExplorer)return;
  window.__fgCategoryExplorer=true;
  const id='fg-category-dialog';
  let activeOpener=null;
  let priorOverflow='';
  const normalize=text=>String(text||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('el-GR').replace(/ς/g,'σ').trim();

  function filterDialog(dialog){
    const input=dialog.querySelector('[data-fg-cat-search]');
    const query=normalize(input?.value);
    const cards=Array.from(dialog.querySelectorAll('[data-fg-cat-card]'));
    let visible=0;
    for(const card of cards){
      const title=normalize(card.querySelector('[data-fg-cat-main]')?.textContent);
      const allChildren=!query||title.includes(query);
      let hasChild=false;
      card.querySelectorAll('[data-fg-cat-subitem]').forEach(child=>{
        const match=allChildren||normalize(child.textContent).includes(query);
        child.hidden=!match;
        if(match)hasChild=true;
      });
      const show=allChildren||hasChild;
      card.hidden=!show;
      if(show)visible++;
    }
    const empty=dialog.querySelector('[data-fg-cat-empty]');
    if(empty)empty.hidden=visible>0;
    const result=dialog.querySelector('[data-fg-cat-results]');
    if(result)result.textContent=visible===1?'1 κύρια κατηγορία':visible+' κύριες κατηγορίες';
  }

  function prepareDialog(dialog){
    if(!dialog||dialog.dataset.fgCatReady==='true')return;
    dialog.dataset.fgCatReady='true';
    dialog.querySelector('[data-fg-cat-search]')?.addEventListener('input',()=>filterDialog(dialog));
    dialog.addEventListener('click',event=>{
      if(event.target===dialog&&dialog.open)dialog.close();
    });
    dialog.addEventListener('close',()=>{
      document.body.style.overflow=priorOverflow;
      document.querySelectorAll('[data-fg-open-categories]').forEach(el=>el.setAttribute('aria-expanded','false'));
      const opener=activeOpener;
      activeOpener=null;
      if(opener?.isConnected)opener.focus({preventScroll:true});
    });
    filterDialog(dialog);
  }

  document.addEventListener('click',event=>{
    const opener=event.target.closest?.('[data-fg-open-categories]');
    if(opener){
      const dialog=document.getElementById(id);
      if(!dialog||typeof dialog.showModal!=='function')return;
      event.preventDefault();
      prepareDialog(dialog);
      if(dialog.open){dialog.close();return;}
      document.querySelectorAll('.fg-header details[open]').forEach(detail=>{detail.open=false});
      activeOpener=opener;
      priorOverflow=document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow='hidden';
      document.querySelectorAll('[data-fg-open-categories]').forEach(el=>el.setAttribute('aria-expanded','true'));
      filterDialog(dialog);
      window.requestAnimationFrame(()=>{
        const desktop=window.matchMedia('(min-width: 700px)').matches;
        (desktop?dialog.querySelector('[data-fg-cat-search]'):dialog.querySelector('[data-fg-close-categories]'))?.focus({preventScroll:true});
      });
      return;
    }
    const close=event.target.closest?.('[data-fg-close-categories]');
    if(close){
      const dialog=close.closest('#'+id);
      if(dialog?.open){event.preventDefault();dialog.close();}
    }
  });

  function prepareDirectory(){
    document.querySelectorAll('[data-fg-dir-filter]').forEach(input=>{
      if(input.dataset.fgDirReady)return;
      input.dataset.fgDirReady='true';
      const directory=input.closest('.fg-directory');
      if(!directory)return;
      const cards=Array.from(directory.querySelectorAll('[data-fg-dir-card]'));
      const brandGroups=Array.from(directory.querySelectorAll('.fg-directory-brands'));
      const status=directory.querySelector('[data-fg-dir-status]');
      const empty=directory.querySelector('[data-fg-dir-empty]');
      const filter=()=>{
        const query=normalize(input.value);
        let shown=0;
        for(const card of cards){
          const matched=!query||normalize(card.textContent).includes(query);
          card.hidden=!matched;
          if(matched)shown++;
        }
        for(const group of brandGroups){
          const allBrands=!query||normalize('Μάρκες '+group.querySelector('h2')?.textContent).includes(query);
          let visibleBrands=0;
          group.querySelectorAll('a').forEach(link=>{
            const matched=allBrands||normalize(link.textContent).includes(query);
            link.hidden=!matched;
            if(matched){visibleBrands++;shown++;}
          });
          group.hidden=visibleBrands===0;
        }
        if(status)status.textContent=shown===1?'1 αποτέλεσμα':shown+' αποτελέσματα';
        if(empty)empty.hidden=shown>0;
      };
      input.addEventListener('input',filter);
      filter();
    });
  }
  function init(){
    prepareDialog(document.getElementById(id));
    prepareDirectory();
  }
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',()=>{
    const dialog=document.getElementById(id);
    if(dialog?.open)dialog.close();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
